// extracted by mini-css-extract-plugin
export default {"container":"_1ZimHA_89A69ksDECVT70h","itemList":"_2bXDNVuSJiKAAW0rGXU0aE"};